<template>
  <div v-html="content"></div>
</template>

<script>
import Interface from "@/util/interface";
export default {
  name: "invite-detail",
  data() {
    return {
      content: ""
    };
  },
  watch: {
    $route: {
      handler() {
        let title = this.$route.query.title;
        Interface.getData("get", Interface.medical.invite, {
          pageSize: 100
        }).then(res => {
          let content = res.data.list.find(item => item.title == title).content;
          this.content = content;
        });
      },
      immediate: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/invite/detail/index.vue